import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, message, Divider, Table, Input, Space, Select, Spin } from "antd";
import { SearchOutlined, BarsOutlined, LoadingOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import { HeaderPage } from "../../../components/headerPage";
import http from "../../../services/http";

const { Text } = Typography;
const antIcon = <LoadingOutlined style={{ fontSize: 18 }} spin />;
const optionsFiltro = [
  { value: 0, label: "Todos" },
  { value: 1, label: "Marcados" },
  { value: 2, label: "Não Marcados" },
];

export const CampanhasFiliais = ({ to }) => {
  const { id_campanha } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // DADOS
  const [dados, setDados] = useState([]);
  const [selected, setSelected] = useState([]);

  //CAMPANHA
  const [campanha, setCampanha] = useState({});

  // FILTRO
  const [marcado, setMarcado] = useState(0);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const buscarDados = async () => {
      if (id_campanha) {
        await listarFiliais(id_campanha);
        const dadosCampanha = await carregarCampanha(id_campanha);
        setCampanha(dadosCampanha ?? {});
      }
    };
    buscarDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id_campanha]);

  // LISTAR
  const listarFiliais = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/campanhas_vacinacao_filiais/listar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      setDados(response?.data ?? []);
      setSelected(response?.checked ?? []);
    } else {
      navigate(to);
      message.error(api.response.message);
    }
    setLoading(false);
  };

  //CARREGAR CAMPANHA
  const carregarCampanha = async (id) => {
    if (!id) return null;
    setLoading(true);
    const api = await http("get", `v1/campanhas_vacinacao/carregar/${id}`, []);
    if (api.statusCode === 200) {
      setLoading(false);
      return api?.response?.data;
    } else {
      navigate(to);
      message.error(api.response.message);
      setLoading(false);
      return null;
    }
  };

  // SALVAR
  const salvarFiliaisCampanha = async (filiais_selected, filiais) => {
    setLoading(true);

    let array_filiais = [];
    filiais?.map((e) => array_filiais.push(e.key));

    const dados_envio = {
      id_campanhas: id_campanha,
      id_cad_filiais: array_filiais,
      id_cad_filiais_checked: filiais_selected,
    };

    const api = await http("post", `v1/campanhas_vacinacao_filiais/adicionar`, dados_envio);
    if (api.statusCode === 200) {
      setSelected((array) =>
        array.filter(function (x) {
          return array_filiais.indexOf(x) < 0;
        })
      );
      setSelected((val) => [...val, ...filiais_selected]);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: (
        <div style={{ height: 23 }}>
          Filial <Spin indicator={antIcon} spinning={loading} />
        </div>
      ),
      dataIndex: "title",
      sorter: (a, b) => a.title?.localeCompare(b.title),
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar, marcado) => {
    let filteredData = dados?.filter((val) => val.title?.toLowerCase().includes(pesquisar.toLowerCase()));

    switch (marcado) {
      case 1:
        filteredData = filteredData.filter((e) => selected.indexOf(e.key) !== -1);
        break;
      case 2:
        filteredData = filteredData.filter((e) => selected.indexOf(e.key) === -1);
        break;
      default:
        break;
    }

    return filteredData;
  };

  // DADOS FILTRADOS
  const dadosFilter = dados?.length > 0 ? handleFilter(search, marcado) : [];

  // CHECK ROW
  const rowSelection = {
    type: "checkbox",
    getCheckboxProps: (record) => ({
      disabled: campanha.status_gerado === 1,
    }),
    selectedRowKeys: selected,
    onSelectAll: (e) => {
      if (loading) return;
      let array = [];
      if (e === true) array = dadosFilter.map((e) => e.key);
      salvarFiliaisCampanha(array, dadosFilter);
    },
    onSelect: (data, status) => {
      if (loading) return;
      salvarFiliaisCampanha(status ? [data.key] : [], [{ key: data.key }]);
    },
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Campanhas de Vacinação" onClickBack={() => navigate(to)} />
            <HeaderTitle
              title={["Campanha de Vacinação", "Filiais"]}
              subtitle={
                <Text italic><EnvironmentOutlined /> {campanha?.titulo_campanha ?? ""}</Text>
              }
              icon={<BarsOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space direction="vertical">
                <Space wrap>
                  <Input
                    size="middle"
                    maxLength={100}
                    prefix={<SearchOutlined />}
                    className="input"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Pesquisar..."
                    allowClear
                  />
                  <Select
                    defaultValue={0}
                    value={marcado}
                    style={{ width: 180, maxWidth: "100%" }}
                    onChange={(e) => setMarcado(e)}
                    options={optionsFiltro}
                  />
                </Space>
              </Space>

              <Divider />

              <Table
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                rowSelection={rowSelection}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
